import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import { ref } from "vue";
import useQuasar from 'quasar/src/composables/use-quasar.js';;
import { useStore } from "vuex";
import UserServices from "@/services/UserServices";

const _userServices = new UserServices();

const tourVisto = ref(true);
let fetched = false;

async function fetchTourVisto(userId) {
  if (fetched) return tourVisto.value;
  try {
    tourVisto.value = await _userServices.getTourVisto(userId);
  } catch (e) {
    tourVisto.value = true;
  }
  fetched = true;
  return tourVisto.value;
}

async function persistTourVisto(userId, visto) {
  tourVisto.value = visto;
  fetched = true;
  try {
    await _userServices.setTourVisto(userId, visto);
  } catch (e) {
  }
}

function homeTourSteps() {
  return [
    {
      element: '[data-tour="user-menu-btn"]',
      popover: {
        title: "Menu de usuário",
        description:
          "Seu avatar agora concentra tudo num só lugar: mudar status (disponível, pausa, indisponível) e sair da plataforma.",
        side: "right",
        onNextClick: (element, step, opts) => {
          const menuBtn = document.querySelector('[data-tour="user-menu-btn"]');
          if (menuBtn && !document.querySelector('[data-tour="user-status-menu"]')) {
            menuBtn.click();
          }
          opts.driver.moveNext();
        },
      },
    },
    {
      element: '[data-tour="user-status-menu"]',
      popover: {
        title: "Status e sair",
        description:
          "Aqui você muda seu status (disponível, pausa ou indisponível) e também sai da plataforma.",
        side: "right",
      },
      waitForElement: 800,
      onDeselected: () => {
        document.querySelector('[data-tour="user-menu-btn"]')?.click();
      },
    },
    {
      element: '[data-tour="help-btn"]',
      popover: {
        title: "Ajuda e suporte",
        description:
          "Novo botão de suporte no canto inferior direito: chat interno, ajuda e envio de feedback ficam aqui.",
        side: "left",
        onNextClick: (element, step, opts) => {
          const helpBtn = document.querySelector('[data-tour="help-btn"]');
          if (helpBtn && !document.querySelector('[data-tour="support-menu-list"]')) {
            helpBtn.click();
          }
          opts.driver.moveNext();
        },
      },
    },
    {
      element: '[data-tour="support-menu-list"]',
      popover: {
        title: "Menu de suporte",
        description:
          "Aqui você também ativa o modo escuro e liga/desliga o tour de novidades a qualquer momento.",
        side: "left",
      },
      waitForElement: 800,
      onDeselected: () => {
        document.querySelector('[data-tour="help-btn"]')?.click();
      },
    },
  ];
}

function askDisableTour($q, uid) {
  $q.dialog({
    title: "Tour de novidades",
    message: "Não mostrar mais os tours de novidades?",
    cancel: { label: "Manter ativado", flat: true },
    ok: { label: "Não mostrar mais" },
    persistent: true,
  }).onOk(() => persistTourVisto(uid, true));
}

function buildTour($q, uid, steps) {
  return driver({
    showProgress: true,
    allowClose: true,
    nextBtnText: "Próximo",
    prevBtnText: "Voltar",
    doneBtnText: "Concluir",
    progressText: "{{current}} de {{total}}",
    popoverClass: "onboarding-tour-popover",
    steps,
    onDestroyStarted: (element, step, opts) => {
      if (opts.driver.isLastStep()) {
        askDisableTour($q, uid);
      }
      opts.driver.destroy();
    },
  });
}

export function useOnboardingTour() {
  const store = useStore();
  const $q = useQuasar();
  const userId = () => store.state.userData?.id_usuario;

  async function startTour(force = false) {
    const uid = userId();
    if (!uid) return;
    if (!force && (await fetchTourVisto(uid))) return;

    const tour = buildTour($q, uid, homeTourSteps());
    tour.drive();
  }

  async function setTourEnabled(enabled) {
    const uid = userId();
    if (!uid) return;
    await persistTourVisto(uid, !enabled);
    if (enabled) {
      startTour(true);
    }
  }

  return { startTour, tourVisto, setTourEnabled };
}
